// extracted by mini-css-extract-plugin
module.exports = {"container":"FromToPicker_container__31zZ-","text":"FromToPicker_text__mu5EU"};